"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _text = _interopRequireDefault(require("@ux/text"));
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _density = require("@site/pattern-library-utils/density");
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
/**
 * Local Imports
 */

const DescriptionWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "DescriptionWrapper",
  class: "pl-dt3spl9",
  vars: {
    "dt3spl9-1": [({
      isMobile = false
    }) => isMobile ? `0.063rem solid ${_intents.default.ux.boxLowContrastOverlay.borderColor}` : 'none']
  }
});

/**
 * DescriptionDrawer component.
 *
 * @param {Object} props React props
 * @param {String} props.descriptionText Description Text
 * @param {Object} props.forwardedRef Forwarded Reference
 * @param {Boolean} props.isMobile Mobile Condition
 * @param {Object} props.style Container Style
 * @returns {React.ReactElement} component
 * @public
 */
function DescriptionDrawer({
  descriptionText,
  forwardedRef,
  isMobile,
  style
}) {
  if (!descriptionText) return null;
  return /*#__PURE__*/_react.default.createElement(DescriptionWrapper, {
    "data-cy": "description-row",
    role: "cell",
    ref: forwardedRef,
    style: style,
    isMobile: isMobile
  }, /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "paragraph",
    size: -2,
    text: descriptionText
  }));
}
var _default = exports.default = DescriptionDrawer;
DescriptionDrawer.propTypes = {
  descriptionText: _propTypes.default.string,
  forwardedRef: _propTypes.default.object,
  isMobile: _propTypes.default.bool,
  style: _propTypes.default.object
};